import * as Types from '../../../../generated/graphql.types';

import gql from 'graphql-tag';
import * as Urql from 'urql';
import { graphql, ResponseResolver, GraphQLRequest, GraphQLContext } from 'msw'
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type DeleteCourseChangeAlertInputMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.DeleteCourseChangeAlertInput>;
}>;


export type DeleteCourseChangeAlertInputMutation = { __typename?: 'MutationRoot', deleteCourseChangeAlert: Array<{ __typename?: 'RouteChangeAlert', courseId: string }> };


export const DeleteCourseChangeAlertInputDocument = gql`
    mutation DeleteCourseChangeAlertInput($input: DeleteCourseChangeAlertInput) {
  deleteCourseChangeAlert(input: $input) {
    courseId
  }
}
    `;

export function useDeleteCourseChangeAlertInputMutation() {
  return Urql.useMutation<DeleteCourseChangeAlertInputMutation, DeleteCourseChangeAlertInputMutationVariables>(DeleteCourseChangeAlertInputDocument);
};

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteCourseChangeAlertInputMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ deleteCourseChangeAlert })
 *   )
 * })
 */
export const mockDeleteCourseChangeAlertInputMutation = (resolver: ResponseResolver<GraphQLRequest<DeleteCourseChangeAlertInputMutationVariables>, GraphQLContext<DeleteCourseChangeAlertInputMutation>, any>) =>
  graphql.mutation<DeleteCourseChangeAlertInputMutation, DeleteCourseChangeAlertInputMutationVariables>(
    'DeleteCourseChangeAlertInput',
    resolver
  )
